export enum AppConstants {
  Platform = 'Web',
  BidRound = 0,
  Token = '00000000-0000-0000-0000-000000000000',
  AppNum = 7,
}

export enum TextPreferencesEnum {
  noTexts = '1',
  send1DayPrior = '2',
  send1HourPrior = '3',
  sendBoth1Day1Hour = '4',
}

export enum Messages {
  UpdatedVersion = 'Updated to the latest version',
  UpdatingVersion = 'Updating to the latest version',
  InvalidVersion = 'Invalid version. Do you want to Update ?',
  DownloadINIStarted = 'Downloading the INI file...',
  SaveDefaultINI = 'Saved the default INI file into local database...',
  DownloadCurrentUserINI = 'Downloading current INI....',
}

export enum BidLineType {
  NormalTrip = 0,
  NoTrip,
  VA,
  VAP,
  VO,
  VD,
  VOFSplit,
  VOBSplit,
  VDDrop,
  VOFSplitDrop,
  VOBSplitDrop,
  FV,
}

export enum BidFileTypes {
  NormalLine = 1,
  Trip,
  Vacation,
  VacationDropOFF,
  Eom,
  EomDropOFF,
  VacationEOM,
  VacationEomDropOFF,
}

export enum BulkCitiesStatusType {
  Normal = 0,
  Yes,
  No,
  Disabled,
}

export class CswConstants {
  public static readonly Any_Night_in_Dom = 'Any Night in Dom';
  public static readonly Commute_to_work = 'Commute to Work';
  public static readonly Commute_to_home = 'Commute to Home';
  public static readonly Ron_Both_ends = 'RON Both ends';
  public static readonly Start_Day = 'Start Day';
  public static readonly Report_Release = `Report Release`;

  public static readonly Report_Release_All_Day_Labal = 'All Day';
  public static readonly Report_Release_TripWork_Labal = 'Trip / Work';
  public static readonly Report_Release_First = 'First';
  public static readonly Report_Release_Last = 'Last';
  public static readonly Report_Release_NoMid = 'No Mid';
}

export enum BlockSortType {
  AMs_then_PMs = 1,
  Blocks_of_Day_Off,
  Days_Off,
  Flight_Time,
  Largest_Blk_of_Days_Off,
  Pay_Credit,
  Pay_per_Day,
  Pay_Per_Duty_Hour,
  Pay_per_Flight_Hour,
  Pay_per_TAFB,
  Per_Diem,
  PMs_then_AMs,
  Start_Day_of_Week,
  Weekday_Pairings,
  Weights,
  Duty_Periods,
  VacPay_Current_Bid_Period,
  Ratio = 19,
  VacPay_Next_Bid_Period,
  VacPay_Both_Current_and_Next,
  ETOPS,
  Commutable_Line_Auto,
  Commutable_Line_Manual,
  ReserveETOPS,
  Line_Rig,
  Vac_Plus_Rig,
  ETOPS_Trips,
  DH_First = 39,
  DH_Last,
  DH_Total,
  LODO = 45,
  Red_Eye_trip_Count = 60, // red eye changes,
  HolRig = 29,
  VpCu_Plus_VaNe = 44, //VpCu+VaNe sort changes
}

export class BidAutomatorConstants {
  public static readonly Am_Pm = 'Am - Pm';
  public static readonly Commutable_Lines = 'Commutable Lines';
  public static readonly Days_of_the_month = 'Days of the month';
  public static readonly Days_of_the_week_All = 'Days of the week - All';
  public static readonly Days_of_the_week_Some = 'Days of the week - Some';
  public static readonly DH_first_last = 'DH - first - last';
  public static readonly Equipment_Type = 'Equipment Type';
  public static readonly Line_Type = 'Line Type';
  public static readonly Overnight_Cities = 'Overnight Cities';
  public static readonly Rest = 'Rest';
  public static readonly Start_Day_of_Week = 'Start Day of Week';
  public static readonly Trip_Length_Block = 'Trip-Work-Block Length';

  public static readonly Am_Pm_Filter_Name = 'AP';
  public static readonly Days_of_the_month_Filter_Name = 'DOM';
  public static readonly Commutable_Lines_Filter_Name = 'CL';
  public static readonly Days_of_the_week_All_Filter_Name = 'DOWA';
  public static readonly Days_of_the_week_Some_Filter_Name = 'DOWS';
  public static readonly DH_first_last_Filter_Name = 'DHFL';
  public static readonly Equipment_Type_Filter_Name = 'ET';
  public static readonly Rest_Filter_Name = 'RT';
  public static readonly Line_Type_Filter_Name = 'LT';
  public static readonly Trip_Length_Block_Filter_Name = 'TBL';
  public static readonly Start_Day_of_Week_Filter_Name = 'SDOW';
  public static readonly Overnight_Cities_Filter_Name = 'OC';

  public static readonly Am_Pm_Filter_Label = 'Am-Pm';
  public static readonly Days_of_the_month_Label = 'Days Of Month';
  public static readonly Commutable_Lines_Label = 'Cmut Lines';
  public static readonly Days_of_the_week_All_Label = 'DOW-All';
  public static readonly DH_first_last_Label = 'DH- First-Last';
  public static readonly Equipment_Type_Label = 'Equipment';
  public static readonly Rest_Label = 'Rest';
  public static readonly Line_Type_Label = 'Line Type';
  public static readonly Trip_Length_Block_Label = 'TrpBlkLen';
  public static readonly Start_Day_of_Week_Label = 'SDOW';
  public static readonly Overnight_Cities_Label = 'Overnight Cities';
  public static readonly Days_of_the_week_Some_Label = 'DOW-Some';

  public static readonly AMs_then_PMs_BlockSort = 'AMs then PMs';
  public static readonly Blocks_of_Day_Off_Block_Sort = 'Blocks of Day Off';
  public static readonly Days_Off_Block_Sort = 'Days Off';
  public static readonly Duty_Periods_Block_Sort = 'Duty Periods (asc)';
  public static readonly Flight_Time = 'Flight Time';
  public static readonly Largest_Blk_of_Days_Off_Block_Sort =
    'Largest Blk of Days Off';
  public static readonly Pay_Credit_Block_Sort = 'Pay Credit';
  public static readonly Pay_per_Day_Block_Sort = 'Pay per Day';
  public static readonly Pay_Per_Duty_Hour_Block_Sort = 'Pay Per Duty Hour';
  public static readonly Pay_per_Flight_Hour_Block_Sort = 'Pay per Flight Hour';
  public static readonly Pay_per_TAFB_Block_Sort = 'Pay per TAFB';
  public static readonly Per_Diem_Block_Sort = 'Per Diem';
  public static readonly PMs_then_AMs_Block_Sort = 'PMs then AMs';
  public static readonly Ratio_Block_Sort = 'Ratio';
  public static readonly Start_Day_of_Week_Block_Sort = 'Start Day of Week';
  public static readonly VacPay_Current_Bid_Period_Block_Sort =
    'VacPay Current Bid Period';
  public static readonly VacPay_Next_Bid_Period = 'VacPay Next Bid Period';
  public static readonly VacPay_Both_Current_and_Next_Block_Sort =
    'VacPay Both Current and Next';
  public static readonly Weekday_Pairings_Block_Sort = 'Weekday Pairings';
  public static readonly Weights_Block_Sort = 'Weights';
  public static readonly ETOPS_Block_Sort = 'ETOPS';
  public static readonly ReserveETOPS_Block_Sort = 'ReserveETOPS';
  public static readonly Commutable_Line_Auto_Block_Sort =
    'Commutable Line-Auto';
  public static readonly Commutable_Line_Manual_Block_Sort =
    'Commutable Line- Manual';
}

export enum SortItem {
  Am_Then_PM = 1,
  Block_Days_Off,
  Days_Off = 3,
  DutyPeriod_Asc = 16,
  Flight_Time = 4,
  Largest_Block_Of_Days_Off,
  Pay_Credit,
  Pay_Per_Day,
  Pay_Per_Duty_Hour,
  Pay_Per_Flight_Hour,
  Pay_Per_TAFB,
  Per_Diem,
  PMs_Then_AMs,
  Start_Day_Of_Week,
  Weekday_Pairings,
  Weights,
  VacPay_Current_Bid_Period = 17,
  VacPay_Next_Bid_Period = 20,
  VacPay_Both_Current_And_Next,
  ETOPS,
  ReserveETOPS,
  Ratio = 19,
  Line_Rig = 26,
  Vac_Plus_Rig,
  ETOPS_Trips,
  Commutable_Line_Auto_Overall = 33,
  Commutable_Line_Auto_Front,
  Commutable_Line_Auto_Back,
  Commutable_Line_Manual_Overall,
  Commutable_Line_Manual_Front,
  Commutable_Line_Manual_Back,
  DH_First,
  DH_Last,
  DH_Total,
  // Red_Eye_trip_Count = 42
  Red_Eye_trips_High_to_Low = 42,
  Red_Eye_trips_Low_to_High = 43,
  LODO = 45,
  HoliRig = 29,
  VpCu_Plus_VaNe = 44, //VpCu+VaNe sort changes
}

export enum BidRound {
  FirstFound = 1,
  SecondRound,
}

export class GlobalSettings {
  public static readonly debrief: number = 30;
}

export class ColorClass {
  // Summary View Colors.
  public static TopHeaderColor = 'rgb(133, 192, 57)';
  public static BottomHeaderColor = 'rgb(238, 255, 217)';
  public static SummaryHeaderColor = 'rgb(207, 226, 183)';
  public static SummaryHeaderBorderColor = 'rgb(158, 179, 131)';

  public static AlternatingLineColor1 = 'rgb(255, 255, 255)';
  public static AlternatingLineColor2 = 'rgb(249, 249, 249)';
  public static ListSeparatorColor = 'rgb(220, 220, 220)';

  public static BlankLineColor = 'rgb(254, 255, 0)';
  public static ReserveLineColor = 'rgb(253, 181, 193)';

  public static activeGreen = 'rgb(133, 192, 57)';
  public static activeOrange = 'rgb(248, 128, 0)';

  public static OffDayColor = 'rgb(226, 0, 9)';
  public static WorkDayColor = 'rgb(135,201,39)';

  public static SummaryViewAMlineColor = 'rgb(216, 109, 148)';
  public static SummaryViewPMLineColor = 'rgb(105, 143, 239)';

  // Modern View Colors.
  public static normDayColor = 'rgb(254, 247, 170)';
  public static weekendDayColor = 'rgb(253, 209, 163)';
  public static nextMonthDayColor = 'rgb(211, 124, 97)';

  public static normTripColor = 'rgb(255, 250, 240)';
  public static weekendTripColor = 'rgb(254, 235, 211)';
  public static nextMonthTripColor = 'rgb(212, 150, 144)';

  public static AMTripColor = 'rgb(216, 109, 148)';
  public static PMTripColor = 'rgb(105, 143, 239)';
  public static MixedTripColor = 'rgb(255,255,0)';

  public static MissedTrip = '#92562e8c';

  public static AMReserveTripColor = 'rgb(253, 191, 203)';
  public static PMReserveTripColor = 'rgb(177, 195, 223)';

  public static VacationTripColor = 'rgb(0, 255, 0)';
  public static VacationTripDayColor = 'rgb(0, 240, 0)';
  public static VAPColor = 'rgb(64, 179, 26)';
  public static VacationDropTripColor = 'rgb(222, 54, 37)';
  public static VacationOverlapTripColor = 'rgb(152, 251, 152)';
  public static OverlapColor = 'rgb(243, 108, 108)';
  public static FVVacationColor = 'rgb(102, 179, 255)';
  public static ReadyReserveColor = 'rgb(265, 165, 0)';
  public static RedEyeTripColor = 'rgb(255, 0, 0)';
  public static ClawbackTripColor = 'rgb(255 156 192)';
}
export enum LineType {
  HARD = 1,
  RELIEF,
  RESERVE,
  MIXED,
  ETOPS,
  LODO,
  AM_RESERVE,
  PM_RESERVE,
  READY_RESERVE,
  SENIOR_AM_RESERVE,
  SENIOR_PM_RESERVE,
  JUNIOR_PM_RESERVE,
  JUNIOR_AM_RESERVE,
  JUNIOR_LATE_RESERVE,
}
